// import { useState, useEffect } from 'react';
// import { Nav, Table, Dropdown, Button, Card } from 'react-bootstrap';
// import { GraduationCap, ChevronDown, Microscope, Trophy, ScrollText } from 'lucide-react';
// import Catalog from '../CoursePages/Catalog';
// import axios from 'axios';
// // import Image from 'next/image';

// const coursesTabs = [
//   "My Courses",
//   "My Grades",
//   "My Memberships",
//   "My Groups",
//   "My Achievements",
//   "My Certificates",
//   "Notifications"
// ];

// const sortOptions = [
//   { label: "Enrollment Date (Most Recent)", value: "date-desc" },
//   { label: "Enrollment Date (Oldest)", value: "date-asc" },
//   { label: "Course Title (A-Z)", value: "title-asc" },
//   { label: "Course Title (Z-A)", value: "title-desc" }
// ];

// export default function CoursesSection() {
//   const [activeTab, setActiveTab] = useState("My Courses");
//   const [selectedSort, setSelectedSort] = useState(sortOptions[0]);
//   const [courses, setCourses] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState(null);

//   useEffect(() => {
//     const fetchCourses = async () => {
//       setLoading(true);
//       const token = localStorage.getItem("jwttoken");
//       try {
//         const response = await axios.get("https://tdtlworld.com/dss-kaas-backend/lms/user/courses/",
//           {
//             headers: {
//               Authorization: `Bearer ${token}`,
//               "Content-Type": "application/json",
//             },
//           });
//         setCourses(response.data);
//       } catch (err) {
//         setError(err.response?.data?.message || 'Failed to fetch courses');
//       } finally {
//         setLoading(false);
//       }
//     };
//     fetchCourses();
//   }, []);

//   const renderContent = () => {
//     if (loading) {
//       return <div className="text-center text-muted py-5">Loading...</div>;
//     }

//     if (error) {
//       return <div className="text-center text-danger py-5">{error}</div>;
//     }

//     if (activeTab === "My Courses") {
//       return (
//         <div className="courses-container">
//           {courses.length > 0 ? (
//             courses.map((course) => (
//               <Catalog
//                 key={course.id}
//                 coursetitle={course.title}
//                 instructor={course.instructor}
//                 price={course.price}
//                 courseId={course.id}
//                 isWishlisted={course.isWishlisted}
//               />
//             ))
//           ) : (
//             <div className="d-flex flex-column align-items-center justify-content-center p-5">
//               <div className="text-muted mb-3">
//                 <GraduationCap size={48} />
//               </div>
//               <p className="text-muted mb-0">You do not have any courses yet.</p>
//             </div>
//           )}
//         </div>
//       );
//     }

//     if (activeTab === "My Grades") {
//       return (
//         <div>
//           <div className="d-flex justify-content-end mb-3 gap-2">
//             <Dropdown>
//               <Dropdown.Toggle
//                 variant="light"
//                 className="d-flex align-items-center gap-2 border"
//               >
//                 {selectedSort.label}
//                 <ChevronDown size={16} />
//               </Dropdown.Toggle>

//               <Dropdown.Menu>
//                 {sortOptions.map((option) => (
//                   <Dropdown.Item
//                     key={option.value}
//                     active={selectedSort.value === option.value}
//                     onClick={() => setSelectedSort(option)}
//                   >
//                     {option.label}
//                   </Dropdown.Item>
//                 ))}
//               </Dropdown.Menu>
//             </Dropdown>
//             <Button variant="primary">Update</Button>
//           </div>

//           <Table hover className="align-middle">
//             <thead>
//               <tr>
//                 <th className="text-muted fw-normal">COURSE</th>
//                 <th className="text-muted fw-normal">ENROLLMENT DATE</th>
//                 <th className="text-muted fw-normal">PROGRESS</th>
//                 <th className="text-muted fw-normal">GRADE</th>
//               </tr>
//             </thead>
//             <tbody>
//               <tr>
//                 <td colSpan={4} className="text-center text-muted py-5">
//                   No grades available
//                 </td>
//               </tr>
//             </tbody>
//           </Table>
//         </div>
//       );
//     }

//     if (activeTab === "My Memberships") {
//       return (
//         <div className="d-flex flex-column align-items-center justify-content-center p-5" style={{ minHeight: '400px' }}>
//           <div className="text-muted mb-3">
//             <Microscope size={48} />
//           </div>
//           <p className="text-muted mb-0">You do not have any memberships yet.</p>
//         </div>
//       );
//     }

//     if (activeTab === "My Groups") {
//       return (
//         <div>
//           <Card
//             className="border-0 bg-light mb-3"
//             style={{ maxWidth: '600px' }}
//           >
//             <Card.Body className="d-flex align-items-center gap-3">
//               <div style={{ width: '80px', height: '80px' }}>
//                 <svg viewBox="0 0 100 100" style={{ width: '100%', height: '100%' }}>
//                   <path
//                     d="M10,10 L90,10 L50,50 L10,10 M10,90 L90,90 L50,50 L10,90 M90,10 L90,90 L50,50 L90,10"
//                     fill="#8B0000"
//                   />
//                 </svg>
//               </div>
//               <div>
//                 <h5 className="mb-0">New Group</h5>
//               </div>
//             </Card.Body>
//           </Card>
//         </div>
//       );
//     }

//     if (activeTab === "My Achievements") {
//       return (
//         <div className="d-flex flex-column align-items-center justify-content-center p-5" style={{ minHeight: '400px' }}>
//           <div className="text-muted mb-3">
//             <Trophy size={48} />
//           </div>
//           <p className="text-muted mb-0">You do not have any achievements yet.</p>
//           <p className="text-muted small">Enroll in a course to get started!</p>
//         </div>
//       );
//     }

//     if (activeTab === "My Certificates") {
//       return (
//         <div className="d-flex flex-column align-items-center justify-content-center p-5" style={{ minHeight: '400px' }}>
//           <div className="text-muted mb-3">
//             <ScrollText size={48} />
//           </div>
//           <p className="text-muted mb-0">You do not have any certificates yet.</p>
//         </div>
//       );
//     }

//     return (
//       <div className="text-center text-muted p-5">
//         {activeTab} content goes here
//       </div>
//     );
//   };

//   return (
//     <div className="card shadow-sm">
//       <div className="card-body p-0">
//         <Nav className="border-bottom gap-4 px-4">
//           {coursesTabs.map((tab) => (
//             <Nav.Item key={tab}>
//               <Nav.Link
//                 onClick={() => setActiveTab(tab)}
//                 className={`py-3 px-1 border-bottom border-3 ${
//                   activeTab === tab ? 'border-primary text-primary' : 'border-transparent text-muted'
//                 }`}
//               >
//                 {tab}
//               </Nav.Link>
//             </Nav.Item>
//           ))}
//           <Nav.Item className="ms-auto">
//             <Nav.Link className="py-3 px-1 text-muted">
//               •••
//             </Nav.Link>
//           </Nav.Item>
//         </Nav>

//         <div className="p-4">
//           {renderContent()}
//         </div>
//       </div>
//       <div className="text-muted small p-3">
//         © 2024 - TDTL MS
//       </div>
//     </div>
//   );
// }

import { useState, useEffect } from 'react'
import { Nav, Card, ProgressBar, Spinner, Button } from 'react-bootstrap'
import { GraduationCap } from 'lucide-react'
import { useNavigate } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronDown } from '@fortawesome/free-solid-svg-icons'
import axios from 'axios'

const coursesTabs = [
  'My Courses',
  'My Grades',
  'My Memberships',

  'My Achievements',
]

export default function CourseSection() {
  const [activeTab, setActiveTab] = useState('My Courses')
  const [displayedCards, setDisplayedCards] = useState(3)
  const [courses, setCourses] = useState([])
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)
  const [role, setRole] = useState('')
  const navigate = useNavigate()

  useEffect(() => {
    const userRole = localStorage.getItem('role')
    setRole(userRole)
  }, [])

  const redirect = (id) => {
    const isAdmin = window.location.pathname.includes('/db-shiksha/kaas/admin/');
    const prefix = isAdmin ? '/db-shiksha/kaas/admin/' : '/db-shiksha/kaas/student/';
    navigate(`${prefix}Course/${id}`)
  }

  useEffect(() => {
    const fetchCourses = async () => {
      setLoading(true)
      const token = localStorage.getItem('jwttoken')

      try {
        const response = await axios.get(
          'https://tdtlworld.com/dss-kaas-backend/lms/user/courses/',
          {
            headers: {
              Authorization: `Bearer ${token}`,
              'Content-Type': 'application/json',
            },
          }
        )

        if (Array.isArray(response.data)) {
          setCourses(response.data)
        } else if (response.data && Array.isArray(response.data.courses)) {
          setCourses(response.data.courses)
        } else {
          setCourses([])
        }
      } catch (err) {
        setError(err.message || 'Failed to fetch courses')
      } finally {
        setLoading(false)
      }
    }
    fetchCourses()
  }, [activeTab])

  const handleViewAll = () => setDisplayedCards(courses.length)
  const handleViewLess = () => setDisplayedCards(3)

  const renderContent = () => {
    if (loading) {
      return (
        <div className='text-center py-5'>
          <Spinner animation='border' variant='primary' />
          <p>Loading...</p>
        </div>
      )
    }

    if (error) {
      return <div className='text-center text-danger py-5'>{error}</div>
    }

    if (activeTab === 'My Courses') {
      return (
        <div className='row'>
          <div className='position-relative mb-2'>
            {displayedCards < courses.length && (
              <div className='mx-2 mt-3'>
                <Button
                  variant='danger'
                  onClick={handleViewAll}
                  data-toggle='tooltip'
                  title='View All Courses'
                  style={{ backgroundColor: '#7D52A0' }}
                >
                  <FontAwesomeIcon icon={faChevronDown} className='me-2' /> View
                  All
                </Button>
              </div>
            )}
            {displayedCards >= courses.length && displayedCards > 3 && (
              <Button
                variant='danger'
                onClick={handleViewLess}
                className='view-less-button'
                data-toggle='tooltip'
                title='View Less Courses'
                style={{
                  backgroundColor: '#B8529E',
                  position: 'absolute',
                  top: '0',
                  left: '0',
                  zIndex: '10',
                }}
              >
                <FontAwesomeIcon
                  icon={faChevronDown}
                  className='me-2'
                  rotation={180}
                />
                View Less
              </Button>
            )}
          </div>

          {Array.isArray(courses) && courses.length > 0 ? (
            courses.slice(0, displayedCards).map((course) => (
              <div
                className='col-md-4 col-sm-6 col-12 mb-4'
                key={course.course_id}
              >
                <Card className='shadow-sm h-100'>
                  <Card.Body>
                    <Card.Title>{course.title}</Card.Title>
                    <Card.Subtitle className='mb-2 text-muted'>
                      Start Date: {course.start_date || 'N/A'}
                    </Card.Subtitle>
                    <Card.Text>
                      <p>Description: {course.description}</p>
                      {role === 'Instructor' ? (
                        <>
                          <div className='d-flex justify-content-between align-items-center p-2 mb-2'>
                            <p>Students: {course.students}</p>
                            <p>
                              Revenue: ₹{course.revenue?.toFixed(2) || '0.00'}
                            </p>
                          </div>
                        </>
                      ) : (
                        <>
                          <strong>Progress:</strong>{' '}
                          {(course.progress * 100).toFixed(2)}%
                          <ProgressBar
                            now={course.progress * 100 || 0}
                            label={`${(course.progress * 100).toFixed(2)}%`}
                            className='mb-2'
                          />
                        </>
                      )}
                      <Button
                        variant='danger'
                        onClick={() => redirect(course.course_id)}
                        style={{ backgroundColor: '#B8529E' }}
                      >
                        View Course
                      </Button>
                    </Card.Text>
                  </Card.Body>
                </Card>
              </div>
            ))
          ) : (
            <div className='d-flex flex-column align-items-center justify-content-center p-5'>
              <div className='text-muted mb-3'>
                <GraduationCap size={48} />
              </div>
              <p className='text-muted mb-0'>
                You do not have any courses yet.
              </p>
            </div>
          )}
        </div>
      )
    }

    return (
      <div className='text-center text-muted p-5'>
        {activeTab} content goes here
      </div>
    )
  }

  return (
    <div className='card shadow-sm'>
      <div className='card-body p-0'>
        <Nav className='border-bottom gap-4 px-4'>
          {coursesTabs.map((tab) => (
            <Nav.Item key={tab}>
              <Nav.Link
                onClick={() => setActiveTab(tab)}
                className={`py-3 px-1 border-bottom border-3 ${
                  activeTab === tab
                    ? 'border-primary text-primary'
                    : 'border-transparent text-muted'
                }`}
              >
                {tab}
              </Nav.Link>
            </Nav.Item>
          ))}
        </Nav>
        <div className='p-4'>{renderContent()}</div>
      </div>
      <div className='text-muted small p-3'>© 2024 - TDTL MS</div>
    </div>
  )
}
